// Countries/regions that require privacy consent popup (GDPR, etc.)
// ISO 3166-1 alpha-2 country codes

export const EU_COUNTRIES = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czechia
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
] as const;

// EEA countries (EU + Iceland, Liechtenstein, Norway)
export const EEA_COUNTRIES = [...EU_COUNTRIES, 'IS', 'LI', 'NO'] as const;

// UK applies UK GDPR post-Brexit
export const UK_COUNTRIES = ['GB'] as const;

// Switzerland has equivalent data protection (FADP)
export const GDPR_ADEQUATE_COUNTRIES = ['CH'] as const;

// All countries requiring privacy popup (GDPR and equivalent)
export const PRIVACY_REQUIRED_COUNTRIES = [
  ...EEA_COUNTRIES,
  ...UK_COUNTRIES,
  ...GDPR_ADEQUATE_COUNTRIES,
] as const;

export const isPrivacyRequiredCountry = (countryCode: string): boolean =>
  PRIVACY_REQUIRED_COUNTRIES.includes(
    countryCode.toUpperCase() as (typeof PRIVACY_REQUIRED_COUNTRIES)[number]
  );
